/** Total number of levels including the final "all-levels" prize level */
export const FINAL_LEVEL_ID = 31;
